import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IonIcon } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import {
  add,
  calendar,
  glasses,
  paw,
  personAdd,
  pricetag,
} from 'ionicons/icons';

@Component({
  selector: 'app-shortcut-overlay',
  templateUrl: './shortcut-overlay.component.html',
  imports: [IonIcon, CommonModule],
  styles: `
    .fab-btn {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 8px 12px;
      height: 40px;
      border-radius: 32px;
      transition: transform .2s;
    }

    .fab-btn:hover {
      transform: translateY(-5px);
    }
  `,
})
export class ShortcutOverlayComponent {
  @Input() open = false;

  @Output() close = new EventEmitter();

  constructor() {
    addIcons({
      add,
      paw,
      pricetag,
      personAdd,
      glasses,
      calendar,
    });
  }

  closeOverlay() {
    this.close.emit();
  }

  action(type: string) {
    // chiude overlay dopo click
    this.close.emit(type);
  }
}
